import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserPermissionDataService } from 'src/app/core/data-services/user-permission/user-permission-data.service';
import { UserMenuItemsOutputDto } from '../data-models/user-permission.data.models';
import { GeneralResponse } from 'src/app/shared/shared-data-models';

@Injectable({
  providedIn: 'root'
})
export class UserMenuService {
  userMenuFetched = new Subject<UserMenuItemsOutputDto[]>();

  constructor(private userPermissionDataService: UserPermissionDataService) { }

  fetchUserMenu() {
    const storedData = localStorage.getItem('userMenu');
    if (!storedData || this.isDataExpired(storedData)) {
      this.userPermissionDataService.GetUserMenu().subscribe({
        next: (res: GeneralResponse<UserMenuItemsOutputDto[]>) => {
          if (res && res.resource) {
            this.mapMenuHierarchy(res.resource);
          }
        }
      });
    } else {
      const menuItems = JSON.parse(storedData).menuItems as UserMenuItemsOutputDto[];
      this.userMenuFetched.next(menuItems);
    }
  }

  private isDataExpired(storedData: string): boolean {
    const data = JSON.parse(storedData);
    const storedTimestamp = data.timestamp;
    const currentTime = new Date().getTime();
    const eightDaysInMillis = 8 * 24 * 60 * 60 * 1000;

    return currentTime - storedTimestamp > eightDaysInMillis;
  }

  private mapMenuHierarchy(items: UserMenuItemsOutputDto[]) {
    const menuMap: { [key: number]: UserMenuItemsOutputDto } = {};
    let mappedItems: UserMenuItemsOutputDto[] = [];

    items.forEach(item => {
      menuMap[item.menuId] = { ...item, childItems: [] };
    });

    items.forEach(item => {
      if (item.parentId === null || item.parentId === undefined) {
        mappedItems.push(menuMap[item.menuId]);
      } else {
        if (menuMap[item.parentId]) {
          menuMap[item.parentId].childItems?.push(menuMap[item.menuId]);
        }
      }
    });

    const dataToStore = {
      timestamp: new Date().getTime(),
      menuItems: mappedItems
    };

    localStorage.setItem('userMenu', JSON.stringify(dataToStore));
    this.userMenuFetched.next(mappedItems);
  }
}
